<div class="card">
    <div class="card-header">
        <div class="d-flex">
            <div>
                <h4 class="mb-0">Taxas SELIC Mensais</h4>
                <small class="text-muted">Histórico das taxas SELIC do Banco Central do Brasil</small>
            </div>
            <div class="ms-auto">
                <button class="btn btn-primary" (click)="syncRates()"><i class="ti ti-refresh"></i> Sincronizar</button>
            </div>
        </div>
    </div>

    <div class="card-body p-0">
        <app-table [tableData]="rates">
            <!-- Header da Tabela -->
            <ng-template app-table-header>
                <th scope="col" class="ps-4">Mês/Ano</th>
                <th scope="col" class="text-end">Taxa SELIC (%)</th>
                <th scope="col" class="pe-4 text-end">Última Atualização</th>
            </ng-template>

            <!-- Body da Tabela -->
            <ng-template app-table-body let-rate>
                <td class="ps-4">
                    <strong>{{ formatDate(rate.referenceDate) }}</strong>
                </td>
                <td class="text-end">
                    <span class="badge bg-primary">{{ formatRate(rate.rate) }}</span>
                </td>
                <td class="pe-4 text-end text-muted">
                    <small>{{ rate.updatedAt | date:'dd/MM/yyyy HH:mm' }}</small>
                </td>
            </ng-template>
        </app-table>

        <!-- Loading overlay -->
        <app-loading-overlay [show]="loading"/>

        <!-- Alert Empty Table -->
        <app-empty-alert-message
                [show]="!loading && rates.length === 0"
                containerClass="m-2"/>
    </div>
</div>

